export default {
    campaignDate: 'Ouverte du {startDate} au {endDate}',
	indicator: {
		end: '✓ Campagne terminée',
		remainingDays: {
			one: '{remainingDays} jour restant',
			other: '{remainingDays} jours restants'
		}
	},
	filters: {
		groupType: 'Typologie de groupement',
		view: 'Vue',
		channel: 'Canaux',
		aggregated: 'Agrégée',
		refresh: 'Actualiser'
	}
};
